import { StyleSheet, Text, View, Image, TouchableOpacity, Dimensions,  BackHandler, Button, StatusBar, ScrollView, ImageBackground, TextInput, TouchableWithoutFeedback, FlatList, Alert} from 'react-native';
import React, {useRef, useState, useEffect, Component} from 'react';
import { FontAwesome5, Feather, MaterialIcons } from '@expo/vector-icons'
import AppLoader, { showLoader, loaderRef, hideLoader } from './AppLoader';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ActivityIndicator } from 'react-native';
import * as SQLite from 'expo-sqlite';
import { Video } from 'expo-av';
import VideoPlayer from 'expo-video-player';
import { createRecentTable, getRecents, SaveRecents } from './getData';
import * as ScreenOrientation from 'expo-screen-orientation';
import AwesomeAlert from 'react-native-awesome-alerts';
import AsyncStorage from '@react-native-async-storage/async-storage';
import moment from "moment";


const carouselRef = React.createRef(null);

const {width, height} = Dimensions.get('window')

const db = SQLite.openDatabase("Users.db");

const video = React.createRef(null);
  
export default class Player extends Component {
  constructor(props) {
    super(props);
    this.state = {
           movie: this.props.route.params.movie,
           status: '',
              plan: '',
              orientationisLandscape: false,
              showAlert: false,
              showAlertExp: false,
              user: {},
            
        }

        
  
      }
      showAlert = () => {
        this.setState({
          showAlert: true
        });
      };
      
      componentDidMount() {
       showLoader();


         //createRecentTable();

         
console.log(this.props.route)

       const key = this.props.route.params.movie.key? this.props.route.params.movie.key : this.props.route.params.movie.id;

         // getRecents();
       //fetch movies from ios.breketefamily.com/getMovies.php
        fetch('https://ios.breketefamily.com/getMoviePlan.php?key='+key)
        .then((response) => response.json())
        .then((responseJson) => {
            console.log(responseJson)
          if(responseJson.status == 0){
            this.setState({
              plan: responseJson.plan,
            }, () => {
              hideLoader();
              
            })
            if(this.state.plan == 'Paid'){

              
              //console.log(today)
              //check if user is loggedIn from asyncstorage
              AsyncStorage.getItem('user').then((user) => {
                if(user){
                  //parse json
                  user = JSON.parse(user);
                  this.setState({user: user})
                  //get expiry date from user
                  let expiry = user.exp_date;
                  console.log(expiry)
                  let today = moment().format('DD/MM/YYYY');
                  //convert dates to date objects
                  today = new Date(today).setHours(0,0,0,0);
                  expiry = new Date(expiry).setHours(0,0,0,0);
                  //check if date is expired
                  if(expiry > today){
                    //if not expired
                    
                    this.setState({
                      video: this.props.route.params.movie.video_url                 
                    })   
                   

                    
                  }else{
                   
                    console.log(expiry)
                    console.log(today)
                    //if expired
                    this.setState({showAlertExp: true})
                    //this.setState({showAlert: true})
                  }

                }else{
                  //if not logged in
                  this.setState({showAlert: true})
                  
                }
              }).catch((err) => {
                alert(err);
              })
            }else{
                this.setState({
                  video: this.props.route.params.movie.video_url                 
                })
            }
          }else{
            hideLoader();
            Alert.alert('Error', responseJson.message);
            this.props.navigation.goBack();
          }

         
        }
        )
        .catch((error) => {
          hideLoader();
          console.error(error);
        }
        );
      
      }

      changeScreenOrientation = async() => {
        console.log(ScreenOrientation.getPlatformOrientationLockAsync())
         

          if(this.state.orientationisLandscape==true){
            await ScreenOrientation.lockPlatformAsync('portrait');
            //this.setState({orientationisLandscape: false})
          }else if(this.state.orientationisLandscape==false){
            await ScreenOrientation.lockPlatformAsync('landscape');
            //this.setState({orientationisLandscape: true})
          }

    }
    saveRecents = (id) => {
      let movieID = id;
      let userID = this.state.user.id;
      fetch('https://ios.breketefamily.com/saveRecent.php?userID='+userID+'&movieID='+movieID)
      .then((response) => response.json())
      .then((responseJson) => {
        console.log(responseJson)
        if(responseJson.status == 0){
          //SaveRecents(responseJson.recent);
          console.log('saved')
        }
      }
      )
      .catch((error) => {
        console.error(error);
      }
      );

      
    }
    toggleOrientation = () => {
        this.setState({orientationisLandscape: !this.state.orientationisLandscape})
        this.changeScreenOrientation();
    }

    
    backhandler = BackHandler.addEventListener('hardwareBackPress', () => {
        console.log('back')
        this.changeScreenOrientation()
        this.props.navigation.goBack();
        return true;
        });

        componentWillUnmount() {
            BackHandler.removeEventListener('hardwareBackPress', this.backhandler);
        }

 routeRecents = () => {
  this.props.navigation.navigate('Recents')
}
 
render(){
  const {showAlert} = this.state;
  const {showAlertExp} = this.state;

  return (
    <SafeAreaView style={{flex:1}}>
    <View style={{flex:1}}>
      <AppLoader ref = { loaderRef } />
     
      </View>
      {/*backbutton*/ }
      <View style={{flexDirection: 'row', justifyContent: 'space-between', padding: 10, paddingTop: 20, paddingBottom: 20, backgroundColor: '#000'}}>
      <TouchableOpacity onPress={() => this.props.navigation.goBack()}>
      <Feather name="arrow-left" size={30} color="#fff" />
      </TouchableOpacity>
     </View>
        <VideoPlayer
            ref={video}
            videoProps={{
                shouldPlay: true,
                defaultControlsVisible: true,
                resizeMode: Video.RESIZE_MODE_CONTAIN,
                source: {
                    uri: this.state.video
                },
                 isMuted: false,
                useNativeControls: true,
                usePoster: true,
                
                posterSource: {
                    uri: this.state.movie.image
                },
                statusBarHidden: false,
                useNativeIOSFullscreenPlayer: true,
                useNativeControlsForIOS: true,
                onPlaybackStatusUpdate: (status) => {
                    if (status.isLoaded && !status.isPlaying) {
                        this.setState({
                            status: 'done'
                        })
                    }
                }
            }}
            onError={(error) => {
                console.log(error);
            }}
            fullscreen={{
                enterFullscreen: this.toggleOrientation,
                exitFullscreen: this.toggleOrientation,
            }}
            onLoad= {this.saveRecents(this.state.movie.key?this.state.movie.key:this.state.movie.id)}
            onFullscreenUpdate={this.toggleScreenOrientation}  
            style={{ width: width, height: height }}
        />
            
        
            <AwesomeAlert
          show={showAlert}
          showProgress={false}
          title="Alert"
          message="This is premium content, please login if you already have a subscription or signup and subscribe to continue"
          closeOnTouchOutside={false}
          closeOnHardwareBackPress={false}
          showCancelButton={true}
          showConfirmButton={true}
          cancelText="No, cancel"
          confirmText="Login/Register"
          confirmButtonColor="#DD6B55"
          onCancelPressed={() => {
            this.setState({showAlert: false});
            this.props.navigation.goBack();
          }}
          onConfirmPressed={() => {
            this.props.navigation.navigate('Profile', {movie: this.state.movie})
          }}
        />

<AwesomeAlert
          show={showAlertExp}
          showProgress={false}
          title="Alert"
          message="Your subscription has expired, please renew your subscription to continue"
          closeOnTouchOutside={false}
          closeOnHardwareBackPress={false}
          showCancelButton={true}
          showConfirmButton={true}
          cancelText="No, cancel"
          confirmText="Renew"
          confirmButtonColor="#DD6B55"
          onCancelPressed={() => {
            this.setState({showAlert: false});
            this.props.navigation.goBack();
          }}
          onConfirmPressed={() => {
            this.props.navigation.navigate('Buy', {user: this.state.user})
          }}
        />

    </SafeAreaView>

  );
}
 

}

const styles = StyleSheet.create({


// CAROUSEL STYLES

carouselImage: {
    width: 200, 
    height: 320, 
    borderRadius: 10, 
    alignSelf: 'center',
    backgroundColor: 'rgba(0,0,0,0.9)'
},
carouselText: {
    paddingLeft: 14,
    color: 'white', 
    position: 'absolute', 
    bottom: 10, 
    left: 2, 
    fontWeight: 'bold'
},
carouselIcon: {
    position: 'absolute', 
    top: 15, 
    right: 15
},
carouselContentContainer: {
    flex: 1,
    backgroundColor: '#000',
    height: 720,
    paddingHorizontal: 14
  },
SearchboxContainer: {
    flexDirection: 'row',
    marginVertical: 20, 
    width: '95%',
    alignSelf: 'center', 
    backgroundColor: '#fff', 
    elevation: 10,
    borderRadius: 4,
  },
  Searchbox: {
    padding: 12,
    paddingLeft: 20,
    fontSize: 16,
  },
  SearchboxIcon: {
    position: 'absolute', 
    right: 20, 
    top: 14
  },
  ImageBg: {
    flex: 1,
    height: null,
    width: null,
    opacity: 1,
    justifyContent: 'flex-start',  
  },
  carouselContainerView: {
    width: '100%',
    height:350 ,
    justifyContent: 'center',
    alignItems: 'center',
},
  carousel: {
    flex:1,
    overflow: 'visible',
} ,
movieInfoContainer: {
  flexDirection: 'row', 
  marginTop: 16, 
  justifyContent: 'space-between', 
  width: Dimensions.get('window').width - 14
},
movieName: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 20,
  marginBottom: 6
},
movieStat: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 14, 
  opacity: 0.8
},
playIconContainer: {
  backgroundColor: '#212121',
  padding: 18,
  borderRadius: 40,
  justifyContent: 'center',
  alignItems: 'center',
  elevation: 25,
  borderWidth: 4,
  borderColor: 'rgba(2, 173, 148, 0.2)',
  marginBottom: 14
}
});
